import React from 'react'
import clsx from 'clsx'
import { lighten, makeStyles } from '@material-ui/core/styles'
import PlusIcon from '@material-ui/icons/Add'
import {
  Toolbar,
  Paper,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'

import TreeList, {
  Column
} from 'devextreme-react/tree-list';
import { useSelector } from 'react-redux'
const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },

  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  dense: {
    margin: theme.spacing(2),
  },
}))

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles()
  const { numSelected, setShowCreate, permissionList } = props

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.actions}>
        {permissionList.some(element => element === "create_local_structure") &&

          <Tooltip title="Əlavə et" placement="top">
            <button
              className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => setShowCreate(true)}
            >
              <PlusIcon />
            </button>
          </Tooltip>}
      </div>
    </Toolbar>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  progresRoot: {
    width: '100%',
    padding: '32px 16px',
  },
  progress: {
    margin: 'auto',
    display: 'block',
    color: '#072C8C',
  },
}))


const expandedKeys = [];
const selectedKeys = [8];

export default function EnhancedTable({
  localStructures,
  isLoading,
  setIsLoading,
  setChooseLocalStructureId,
  setShowCreate,
  isError
}) {
  const classes = useStyles()
  const permissionList = useSelector(state => state.auth.permissionList)

  const onRowClick = (e) => {
    setChooseLocalStructureId(e.data.id)
  }


  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar setShowCreate={setShowCreate} permissionList={permissionList} />

        <div className="pb-3 px-4">
          {localStructures.length ? (
            <TreeList
              dataSource={localStructures}
              showBorders={true}
              columnAutoWidth={true}
              wordWrapEnabled={true}
              defaultExpandedRowKeys={expandedKeys}
              defaultSelectedRowKeys={selectedKeys}
              keyExpr="id"
              parentIdExpr="parentId"
              id="localStructures"
              // onRowClick={onRowClick}
            >
              <Column dataField="name" width={300} dataId="id" />
            </TreeList>
          ) : !localStructures.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>
      </Paper>
    </div>
  )

}
